import { createContext, useContext, type ReactNode } from "react";

/** Shell controls displayed inside the two persistent creation panes. */
export const CreationWorkspaceChromeContext = createContext<{
  projectControls: ReactNode;
  accountControls: ReactNode;
  /** The shell owns the active image canvas while retaining composer drafts. */
  editorHosted?: boolean;
} | null>(null);
export const useCreationWorkspaceChrome = () => useContext(CreationWorkspaceChromeContext);

export type WorkspaceCreationMedia = "image" | "video" | "audio" | "3d";

export interface CreationWorkspaceLayout {
  media: WorkspaceCreationMedia;
  resultsTarget: HTMLElement | null;
  /** Registers whether this retained composer has actual result/detail content. */
  registerDetail: (id: string, visible: boolean) => () => void;
}

/** Present only inside the retained controls of the shared creation workspace. */
export const CreationWorkspaceLayoutContext = createContext<CreationWorkspaceLayout | null>(null);
export const useCreationWorkspaceLayout = () => useContext(CreationWorkspaceLayoutContext);
